import { render, staticRenderFns } from "./Baskets.vue?vue&type=template&id=1815bf28"
import script from "./Baskets.vue?vue&type=script&lang=js"
export * from "./Baskets.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Baskets.vue?vue&type=style&index=1&id=1815bf28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports